<div>
    <div class="page-not-found">
      <dxp-content-item content-type="content-image-text" header-type="image" orientation="horizontal"
        content-item-type="media-on-top" position-of-media="right" content-item-title-target=false
        category-tag="" src="assets/images/action-failed.png" alt="Mastercard" overlay=false responsive=true
        icon-type="light" indentation=true image-shape="circle" image-height=562 image-width=562 height=562
        eyebrow-text="Whoops!" content-item-title="Something went wrong"
        description="Please try again. If the problem continues, contact us">
      </dxp-content-item>
    </div>
  </div>